<template>
    <v-dialog
        v-model="dialog"
        max-width="90%"
        height="90%"
    >
        <v-card>
            <v-card-title class="text-h5">
                <div class="add-files_header">
                    <h2>{{title}}</h2>
                    <button class="filter-btn" @click="close()">
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L13.7279 13.7279" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
                            <path d="M1 14L13.7279 1.27208" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                </div>
            </v-card-title>
            <v-card-text class="d-flex">
                <img height="600" class="image-pop" v-if="image" :src="url" alt="">
                <iframe width="100%" height="600" class="image" v-else :src="url" frameborder="0"></iframe>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'MediaViewDIalog',
    data: () => ({
        dialog: false,
        title: '',
        image: false,
        url: ''
    }),
    computed: {
        ...mapGetters({
            apiImg: "apiImg"
        })
    },
    methods: {
        open(item) {
            const type = item.fileUrl.split('.').pop();
            this.image = (type === 'webb' || type === 'png' || type === 'jpg' || type === 'jpeg');

            this.title = item.fileName;
            this.url = `${this.apiImg}${item.fileUrl}`;
            this.dialog = true;
        },
        close() {
            this.title = '';
            this.url = '';
            this.dialog = false;
        }
    }
}
</script>
